import type { ComponentProps } from "react";

import { cn } from "@/lib/utils/cn";

export function Table({ className, ...props }: ComponentProps<"table">) {
    return (
        <div className="relative w-full overflow-x-auto rounded-lg border">
            <table className={cn("w-full caption-bottom text-[0.9375rem]", className)} {...props} />
        </div>
    );
}

export function TableHeader(props: ComponentProps<"thead">) {
    return <thead className="bg-muted/50 [&_tr]:border-b" {...props} />;
}

export function TableBody(props: ComponentProps<"tbody">) {
    return <tbody className="[&_tr:last-child]:border-0" {...props} />;
}

export function TableRow({ className, ...props }: ComponentProps<"tr">) {
    return <tr className={cn("border-b transition-colors hover:bg-muted/40", className)} {...props} />;
}

export function TableHead({ className, ...props }: ComponentProps<"th">) {
    return (
        <th
            className={cn(
                "h-9 px-3 text-left align-middle text-xs font-medium uppercase text-muted-foreground",
                className,
            )}
            {...props}
        />
    );
}

export function TableCell({ className, ...props }: ComponentProps<"td">) {
    return <td className={cn("px-3 py-2 align-middle", className)} {...props} />;
}
